import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ClientProjects" }

import { computed, PropType } from "vue";
import { Client } from "@/types";
import { useProjectStore } from "@/stores/projects";
import ClientButton from "@/components/general/ClientButton.vue";
import ProjectButton from "@/components/general/ProjectButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientProjects',
  props: {
    client: {
        type: Object as PropType<Client>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const projectsStore = useProjectStore();

const projects = computed(() => {
    return projectsStore.list.filter(
        (project) => project.clientId === props.client.id
    );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projects.value, (project, index) => {
      return (_openBlock(), _createBlock(ProjectButton, {
        key: index,
        project: project
      }, null, 8, ["project"]))
    }), 128))
  ]))
}
}

})